(() => {
  if (window.__xophLinksTracking) return;
  window.__xophLinksTracking = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-xoph-link-id]');

    if (!link || window.Shopify?.designMode) return;

    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;

    try {
      const result = publish.call(
        window.Shopify.analytics,
        'xoph:link_clicked',
        {
          link_id: link.dataset.xophLinkId,
          link_label: link.dataset.xophLinkLabel,
          link_type: link.dataset.xophLinkType,
          page_path: window.location.pathname
        }
      );

      if (result && typeof result.catch === 'function') {
        result.catch(() => {});
      }
    } catch (_) {
      // Tracking failures must never block navigation.
    }
  });
})();